import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import Header from "./components/feature/Header";
import Footer from "./components/feature/Footer";

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      let attempts = 0;
      let targetFound = false;
      let timer: number;

      const scrollToTarget = () => {
        const target = document.getElementById(id);
        if (target) {
          targetFound = true;
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

      const tryScroll = () => {
        const target = document.getElementById(id);
        if (target) {
          targetFound = true;
          scrollToTarget();
          return;
        }
        attempts += 1;
        if (attempts < 20) {
          timer = window.setTimeout(tryScroll, 100);
        } else {
          window.scrollTo(0, 0);
        }
      };

      tryScroll();

      // Re-scroll once the destination page finishes loading (images, fonts,
      // late content) so the section doesn't drift away from the viewport.
      const settleTimer = window.setTimeout(() => {
        if (targetFound) {
          scrollToTarget();
        }
      }, 600);

      return () => {
        window.clearTimeout(timer);
        window.clearTimeout(settleTimer);
      };
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToHash />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
